module.exports = __webpack_public_path__ + "img/ic_plus_sign_white.063695e8.svg";